import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'dhats-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
})
export class CardComponent {
  padding = input<'none' | 'sm' | 'md' | 'lg'>('md');
  
  get paddingClass(): string {
    switch (this.padding()) {
      case 'none': return 'p-0';
      case 'sm': return 'p-4';
      case 'md': return 'p-6';
      case 'lg': return 'p-8';
      default: return 'p-6';
    }
  }
}
